export const AUTH_API_URL = `${process.env.NX_SERVER_URL}auth`;

export const VERIFY_EMAIL_API_URL = 'ui/email_verification_processes';

export const verifyEmailQueryKeys = {
  base: [VERIFY_EMAIL_API_URL],
};
